import { render, staticRenderFns } from "./Report.Screenproof.Created.vue?vue&type=template&id=bb84c374&scoped=true&"
import script from "./Report.Screenproof.Created.vue?vue&type=script&lang=js&"
export * from "./Report.Screenproof.Created.vue?vue&type=script&lang=js&"
import style0 from "./Report.Screenproof.Created.vue?vue&type=style&index=0&id=bb84c374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb84c374",
  null
  
)

export default component.exports